export default __webpack_public_path__ + "media/src/usersite/images/footer/x_logo-4d73a49285dbe9cac801b0070e254d4c.png";